export default __webpack_public_path__ + "e329e93c405f4db2aeea7d96d3c59f66.svg";